module.exports = __webpack_public_path__ + "img/20210618_153619.5d3d2e9b.jpg";